import React, { useContext, useState } from 'react'
import { RootContext as store } from '~/state'
import { ZoomIn, ZoomOut } from '../icons'

export const ZoomControl = (): JSX.Element => {
  const { setZoom } = useContext(store)

  const [zoom, setInputZoom] = useState(100)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const value = Number(e.target.value)
    setInputZoom(value)
    setZoom(value)
  }

  return (
    <div className="zoom-control">
      <ZoomOut mode="dark" />
      <input type="range" min={75} max={125} step={1} defaultValue={100} value={zoom} onChange={handleChange} />
      <ZoomIn mode="dark" />
      <style jsx>{`
        .zoom-control {
          height: 24px;
          display: flex;
          align-items: center;
        }

        input {
          margin-left: 8px;
          margin-right: 8px;
        }
      `}</style>
    </div>
  )
}
